/**
 *
 * @param url
 * @return {{}}
 */
function parseURL(url) {
  url = url.split('?')[1]
  let match,
    pl = /\+/g, // Regex for replacing addition symbol with a space
    search = /([^&=]+)=?([^&]*)/g,
    decode = function (s) {
      return decodeURIComponent(s.replace(pl, ' '))
    },
    query = url

  let urlParams = {}
  while ((match = search.exec(query))) {
    urlParams[decode(match[1])] = decode(match[2])
  }
  return urlParams
}

export default parseURL
